import { Button, TableItem, TableMessage } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { Table } from 'components/organisms';
import { useFormikContext } from 'formik';
import { useParamId } from 'hooks/useParamId';
import { useTranslation } from 'react-i18next';
import { PiPlus, PiTrash } from 'react-icons/pi';
import { IAdvance } from 'services/advance/types';
import { useGetContractsByLabel } from 'services/contract';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const AdvanceContracts = () => {
  const { t } = useTranslation();

  const labelId = useParamId('label');

  const { data } = useGetContractsByLabel(labelId, {
    params: { itemCount: 999, page: 0 },
  });

  const { values, setFieldValue, status } = useFormikContext<IAdvance>();

  const contracts = data?.pages
    ? data?.pages.flat().map(e => {
        return {
          title: e.title,
          id: e.id,
        };
      })
    : [];

  const availableContracts = contracts.filter(
    contract =>
      !values.contracts?.some(
        selectedContract => selectedContract.id === contract.id
      )
  );

  const contractOptions = availableContracts.map(c => ({
    label: c.title,
    value: c.id,
  }));

  return (
    <>
      {!values.repaymentsFromAllContracts && (
        <Table
          id={'AdvanceContracts'}
          size='compact'
          data={{
            nodes: values.contracts
              ? values.contracts?.map((contract, idx) => ({
                  index: idx,
                  title: contract.title,
                  id: contract.id,
                }))
              : [],
          }}
          columns={[
            {
              label: t('label.table.contracts'),
              renderCell: ({ index, id, title }) => (
                <div className='flex justify-between'>
                  <FormInput.Select
                    options={contractOptions}
                    name={`contracts[${index}].id`}
                    value={{
                      label: title,
                      value: id,
                    }}
                    onChange={newValue => {
                      setFieldValue(
                        `contracts[${index}].title`,
                        newValue.label
                      );
                    }}
                  />
                  {!status?.displayMode && (
                    <Button
                      variant={BUTTON_VARIANT.remove}
                      isClear
                      onlyIcon
                      onClick={() => {
                        setFieldValue(
                          'contracts',
                          values.contracts.filter(
                            contract => contract.id !== id
                          )
                        );
                      }}>
                      <Button.Icon icon={<PiTrash />} />
                    </Button>
                  )}
                </div>
              ),
              resize: true,
            },
          ]}
          tableOptions={
            status?.displayMode
              ? undefined
              : {
                  renderAfterTable: () => (
                    <tfoot className='full-width-footer'>
                      <TableMessage
                        className='cursor-pointer'
                        onClick={() => {
                          setFieldValue(
                            `contracts[${values.contracts.length}]`,
                            {
                              id: '',
                              title: '',
                            }
                          );
                        }}>
                        <TableItem.Text text={t('button.add')} />
                        <PiPlus />
                      </TableMessage>
                    </tfoot>
                  ),
                }
          }
        />
      )}
    </>
  );
};

export default AdvanceContracts;
